var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.341 71.9995C132.535 71.9995 133.508 71.0303 133.465 69.8364C132.964 55.9446 127.652 42.6311 118.4 32.196C108.67 21.2204 95.2556 14.1894 80.6933 12.4318C66.1311 10.6742 51.4294 14.3119 39.3669 22.6572C27.3043 31.0026 18.7167 43.4775 15.2268 57.7242C11.737 71.971 13.5868 87.0026 20.4267 99.9782C27.2665 112.954 38.6225 122.974 52.3485 128.146C66.0744 133.318 81.2194 133.283 94.9211 128.047C107.948 123.069 118.812 113.718 125.677 101.63C126.267 100.592 125.852 99.2826 124.793 98.7305C123.733 98.1783 122.431 98.5921 121.838 99.6293C115.464 110.78 105.416 119.405 93.3768 124.006C80.6631 128.864 66.6101 128.897 53.8739 124.098C41.1377 119.299 30.6005 110.001 24.2538 97.9608C17.9072 85.9208 16.1907 71.973 19.4289 58.7536C22.6671 45.5341 30.6356 33.9587 41.8283 26.2151C53.0211 18.4715 66.6627 15.0961 80.1749 16.727C93.6872 18.3578 106.134 24.8818 115.163 35.0661C123.713 44.7097 128.637 57.0027 129.136 69.8366C129.182 71.0304 130.146 71.9995 131.341 71.9995Z",
    fill: "#7663EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 71.9998L64.5 89.9998L100.5 53.9998",
    stroke: "#7663EB",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.cd56eab525c279f3b300f64ee81a2374.svg";
export { ForwardRef as ReactComponent };